// extracted by mini-css-extract-plugin
export var active = "_2n-9";
export var backButton = "_2n-8";
export var clone = "_2n-e";
export var collapseBar = "_2n-k";
export var collapseMode = "_2n-m";
export var collapsed = "_2n-o";
export var dimmed = "_2n-i";
export var dragHandle = "_2n-c";
export var dropdownIcon = "_2n-g";
export var expanding = "_2n-n";
export var hidden = "_2n-x";
export var iconContainer = "_2n-q";
export var iconSwapper = "_2n-w";
export var navItem = "_2n-6";
export var navItemIcon = "_2n-f";
export var navProfile = "_2n-7";
export var notificationCountBadge = "_2n-j";
export var notificationDot = "_2n-r";
export var optionsContainer = "_2n-h";
export var primaryNav = "_2n-0";
export var primaryNavDivider = "_2n-v";
export var primaryNavResizeHandle = "_2n-2";
export var primaryNavResizing = "_2n-1";
export var primaryNavTabSection = "_2n-u";
export var primaryTab = "_2n-p";
export var primaryTabIconBox = "_2n-s";
export var secondaryNav = "_2n-3";
export var selected = "_2n-t";
export var settingsNav = "_2n-4";
export var settingsNavItems = "_2n-5";
export var show = "_2n-d";
export var sideNav = "_2n-l";
export var teamItem = "_2n-a";
export var userProfileItem = "_2n-b";